import { useEffect, useState, useRef } from 'react';
import './index.scss'
import { useHistory } from "react-router-dom";
import * as Api from '../../api/common';
import Const from '../../utils/Const';

/**列表页面 */
interface Props {

}
const Index = (parent: Props) => {
    const history = useHistory();
    const [list, setList]: any = useState([
        // { name: '201-1' },
        // { name: '201-2' },
        // { name: '201-3' },
        // { name: '201-4' },
        // { name: '201-5' },
        // { name: '201-6' },
        // { name: '201-7' },
    ]);
    const [active, setActive]: any = useState('')

    useEffect(() => {
        getList()
        let time = setInterval(() => {
            getList()
        }, 1000 * 60)
        return () => {
            clearInterval(time)
        }
    }, [])

    const getList = () => {
        Api.getlist().then((res: any) => {
            console.log(res)
            if (res.success) {
                setList(res.data.list)
            }
        })
    }

    const listClick = (value) => {
        console.log(value, value.value)
        // Const.selectName = value.roomName;
        setActive(value.name);
        sessionStorage.setItem('selectName', value.roomName)
        sessionStorage.setItem('path', '/conferenceRoom')
        sessionStorage.setItem('state', JSON.stringify(value))
        history.push({ pathname: `/conferenceRoom`, state: { value: value } });
    }

    return <div className="main-content list" >
        <div className="tit flex-c-c">会议室列表</div>
        <div className="content flex-c-s">
            {list.map((item, index) => {
                return <div className={`li flex-c-s  ${item.name === active && 'active'}`} key={index} onClick={() => listClick(item)}>
                    <div className="text flex-c-l">{item.roomName}</div>
                    {item.name === active && <div className="btn flex-c-c">当前</div>}
                    {item.name !== active && <div className="btn flex-c-c">选择</div>}
                </div>
            })}
        </div>
    </div >
}
export default Index
